import React, { useState } from 'react';

export const CalendarContext = React.createContext(null);

// eslint-disable-next-line react/prop-types
export default ({ children }) => {
    const [userSelection, setUserSelection] = useState(null);

    return (
        <CalendarContext.Provider value={{ userSelection, setUserSelection }}>{children}</CalendarContext.Provider>
    );
};
